import { useEffect, useRef } from 'react';

export function useScrollToFocus(enabled = true) {
  const ref = useRef<HTMLDivElement>(null);
  const enabledRef = useRef(enabled);
  enabledRef.current = enabled;

  useEffect(() => {
    const block = ref.current;
    if (!block) return;

    const handler = () => {
      window.setTimeout(() => {
        if (!enabledRef.current) return;
        block.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    };

    block.addEventListener('click', handler);
    return () => block.removeEventListener('click', handler);
  }, []);

  return ref;
}
